/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/ban-types */
import * as Communicator from "@ts3d-hoops/web-viewer";
import { Lodash } from "utils/utils";

export default class CallbackManagerExtend {
    private mapCallbacksExtend: Map<
        Communicator.CallbackMapExtendKey,
        Function[]
    > = new Map();
    triggerExtend(): void {
        if (arguments.length > 0) {
            const [name, ...arg] = Array.from(arguments);
            if (typeof name === "string") {
                const nameEvent = name as Communicator.CallbackMapExtendKey;
                const callbacks = this.mapCallbacksExtend.get(nameEvent);
                if (callbacks && Array.isArray(callbacks)) {
                    callbacks.forEach((callback) => {
                        callback(...arg);
                    });
                }
            }
        }
    }
    bind(callbacks: Communicator.CallbackMapExtend): void {
        if (callbacks && typeof callbacks === "object") {
            Object.keys(callbacks).forEach((nameCallback) => {
                const nameEvent =
                    nameCallback as Communicator.CallbackMapExtendKey;
                const currCallbacks = this.mapCallbacksExtend.get(nameEvent);
                const callbackInput = callbacks[nameEvent];
                if (currCallbacks) {
                    const arrCurrCallbacks = Array.isArray(currCallbacks)
                        ? currCallbacks
                        : [currCallbacks];
                    arrCurrCallbacks.push(callbackInput);
                } else {
                    this.mapCallbacksExtend.set(nameEvent, [callbackInput]);
                }
            });
        }
    }
    unbind(callbacks: Communicator.CallbackMapExtend): void {
        if (callbacks && typeof callbacks === "object") {
            Object.keys(callbacks).forEach((nameCallback) => {
                const nameEvent =
                    nameCallback as Communicator.CallbackMapExtendKey;
                const currCallbacks = this.mapCallbacksExtend.get(nameEvent);
                const callbackInput = callbacks[nameEvent];
                if (currCallbacks) {
                    const arrCurrCallbacks = Array.isArray(currCallbacks)
                        ? currCallbacks
                        : [currCallbacks];
                    Lodash.remove(
                        arrCurrCallbacks,
                        (call) => call === callbackInput
                    );
                }
            });
        }
    }

    onDestroy(): void {
        this.onClearMap();
    }

    // private
    private onClearMap() {
        this.mapCallbacksExtend.clear();
    }
}
